export default __webpack_public_path__ + "static/media/i-circule-big.f7f08081.svg";